/**
 * Sorts subcategories alphabetically, with categories that require a description
 * (e.g. "Other") pushed to the bottom of the list.
 */
export function sortSubcategories<
	T extends { name: string; requiresDescription?: boolean },
>(items: T[]): T[] {
	return [...items].sort((a, b) => {
		if (a.requiresDescription && !b.requiresDescription) return 1
		if (!a.requiresDescription && b.requiresDescription) return -1
		return a.name.localeCompare(b.name)
	})
}
